import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { transactionRefetchQueries1 } from '~/modules/billing-invoicing/bill/components/BillDetails/components/hooks/useTransactionRefetchQueries';

const DELETE_CREDITMEMO = gql`
  mutation deleteCreditMemo($id: String!) {
    deleteCreditMemo2(id: $id)
  }
`;

export const useDeleteCreditMemo = () => {
  const [deleteCreditMemo] = useMutation(DELETE_CREDITMEMO);

  return {
    deleteCreditMemo: ({ id }) =>
      deleteCreditMemo({
        variables: {
          id
        },
        refetchQueries: [...transactionRefetchQueries1],
        awaitRefetchQueries: true
      })
  };
};

export default useDeleteCreditMemo;
